module.exports = __webpack_public_path__ + "static/media/undraw_certification_re_ifll.b6693118.svg";